import {Component, OnInit} from '@angular/core';
import {Cart} from '../orderSingletone/Cart';
import {DressesService} from '../../services/dresses/dresses.service';
import {UiService} from '../../services/ui-service/ui.service';

import {ApiService} from '../../services/api-service/api.service';
import {ActivatedRoute} from '@angular/router';

@Component({
	selector: 'app-dresses-carousel',
	templateUrl: './dresses-carousel.component.html',
	styleUrls: ['./dresses-carousel.component.scss']
})
export class DressesCarouselComponent implements OnInit {

	//todo implement viewParent/viewChild relations

	private cart = Cart.getInstance();
	private selectedDress;
    private router: ActivatedRoute;
	public dresses: any[];
	public staticUrl: string;

	currentTitle = 'Наши фотографы';
	carouselItems = [
		{
			image: '',
			images: [],
			title: '',
			price: null,
			index: 1
		},
	];

	private detailsItem = null;

	openModal = (event) => {
		this.UIservice.toggleCallbackModal(event);
	  }

	getDetailsItem = () => {
		return this.detailsItem;
	}

	setDetailsItem = (value) => {
		this.detailsItem = value;
	}

	scrollHorizontally = (e) => {
		e = window.event || e;
		let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
		document.getElementsByClassName('dresses-carousel')[0].scrollLeft -= (delta * 50); // Multiplied by 40
		e.preventDefault();
	}

	showDressDetails = (item) => {
		let target = document.getElementsByClassName('dress-details')[0];
		if (target.classList.contains('open')) {
		} else {
			target.classList.add('open');
		}
	}

	hideDressDetails = () => {
		document.getElementsByClassName('dress-details')[0].classList.remove('open');
	}

	addDressToCart = (dress, event) => {
		this.dressesService.addDress(dress);
	}

	constructor(private dressesService: DressesService, private UIservice: UiService,private apiService: ApiService) {
		this.carouselItems = this.apiService.dresses;
		this.detailsItem = this.carouselItems;
		this.staticUrl = this.apiService.static_link;
	}

	ngOnInit() {
		if (screen.width > 768) {
			if (document.getElementsByClassName('dresses-carousel')[0].addEventListener) {
				document.getElementsByClassName('dresses-carousel')[0].addEventListener('mousewheel', this.scrollHorizontally, false);
				document.getElementsByClassName('dresses-carousel')[0].addEventListener('DOMMouseScroll', this.scrollHorizontally, false);
			}
			// this.dressesService.getSelectedDress().subscribe(dress => {this.selectedDress = dress;});

		}

	}
}


